export enum PermissionConsts {
    Pages_Users = 'Pages.Users',
    User_Create = 'Users.Create',
    User_Detail = 'User.Detail',
    User_Edit = 'User.Edit',
    User_Delete = 'User.Delete',
    User_Get = 'User.Get',
}
